// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import userAnswer css modules
import userAnswerStyles from '../userAnswerModuleStyles.css';

function UserAnswerListItem({ userAnswer }) {
  return (
    <li>
      <Link to={`/user-answers/${userAnswer._id}`}> {userAnswer.name}</Link>
    </li>
  )
}

UserAnswerListItem.propTypes = {
  userAnswer: PropTypes.object.isRequired
}

export default UserAnswerListItem;



// WEBPACK FOOTER //
// modules/userAnswer/components/UserAnswerListItem.js.jsx